import { FC } from "react";
import useStore from "../hooks/useStore";
import { addToCart, registerAnalyticsEvent } from "../util/webinars";
import WebinarSlot, { WebinarProps } from "./WebinarSlot";

type TodaysWebinarsProps = {
  webinars: WebinarProps[];
  day: Date;
};

const TodaysWebinars: FC<TodaysWebinarsProps> = ({ webinars, day }) => {
  const openWebinarDialog = useStore((state) => state.openWebinarDialog);

  if (webinars && webinars.length > 0) {
    return (
      <div className="tw-flex tw-flex-col tw-space-y-14 tw-w-full tw-mt-4">
        {webinars
          .sort(
            (webinarA, webinarB) =>
              new Date(webinarA.StartDateString).getTime() -
              new Date(webinarB.StartDateString).getTime()
          )
          .map((webinar: any, idx: number) => (
            <WebinarSlot
              key={idx}
              Title={webinar.Title}
              Price={webinar.Price}
              ProductTime={webinar.ProductTime}
              ID={webinar.ID}
              IsNew={webinar.IsNew}
              StartDateString={webinar.StartDateString}
              ProductCredits={webinar.ProductCredits}
              onWebinarClick={() => openWebinarDialog(webinar.ID, day)}
              onAddToCart={() => {
                registerAnalyticsEvent("TSG_cal_addtocart_direct");

                addToCart({
                  CourseID: webinar.ID,
                  ProductID: webinar.ProductID,
                  Acronym: webinar.Acronym,
                  ProductCodes: webinar.ProductCodes,
                  UnitPrice: webinar.UnitPrice,
                  IsMobile: webinar.IsMobile,
                  ProductCredits: webinar.ProductCredits,
                  Title: webinar.Title,
                  ProductDate: webinar.ProductDate,
                  ProductTime: webinar.ProductTime,
                });
              }}
            />
          ))}
      </div>
    );
  }
  return null;
};

export default TodaysWebinars;
